import { AttachmentIcon, FaroText, grey } from "@faro-lotv/flat-ui";
import { Stack } from "@mui/system";
import type { JSX } from "react";

type CardAttachmentIconProps = {
  /** the number of attachments for this annotation */
  count: number;
};

/** @returns An icon with an indicator of the number of attachment */
export function CardAttachmentIcon({
  count,
}: CardAttachmentIconProps): JSX.Element {
  return (
    <Stack
      direction="row"
      sx={{ alignItems: "center", opacity: count > 0 ? 1 : 0 }}
    >
      <AttachmentIcon
        sx={{ color: grey[500], width: "18px", height: "18px" }}
      />
      <FaroText variant="bodyM" sx={{ opacity: count > 0 ? 1 : 0 }}>
        {count}
      </FaroText>
    </Stack>
  );
}
